/**
 * Dashboard Store — Stato globale dashboard condiviso tra nav desktop e bottom-nav.
 *
 * Uso nei template:
 *   $store.dashboard.pendingQuizCount   — numero quiz pendenti (badge nav "Test")
 */
export function registerDashboardStore(Alpine) {
    Alpine.store('dashboard', {
        pendingQuizCount: 0,
        _loaded: false,

        init() {
            // Solo su pagine dashboard e con utente autenticato
            if (!window.location.pathname.startsWith('/dashboard')) return;
            if (!window.IKOS?.authToken) return;

            this.fetchPendingQuizzes();
        },

        async fetchPendingQuizzes() {
            if (this._loaded) return;

            try {
                const apiBase = window.IKOS?.apiBase || '';
                const headers = { 'Accept': 'application/json' };

                const authToken = window.IKOS?.authToken;
                if (authToken && authToken !== true) {
                    headers['Auth-Token'] = authToken;
                }

                const guestId = window.IKOS?.guestId;
                if (guestId) {
                    headers['X-Guest-Id'] = guestId;
                }

                const res = await fetch(apiBase + '/v1/users/me/pending-quizzes', { headers });
                if (!res.ok) throw new Error('API ' + res.status);

                const data = await res.json();
                this.pendingQuizCount = data.total_items ?? 0;
                this._loaded = true;
            } catch (e) {
                this.pendingQuizCount = 0;
            }
        },
    });
}
